export const FilterSvg = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.465793 2.21134C-0.288556 1.34923 0.323687 0 1.46923 0H10.5309C11.6764 0 12.2887 1.34923 11.5343 2.21134L8.00005 6.25049V11C8.00005 11.824 7.05929 12.2944 6.40005 11.8L4.40005 10.3C4.14824 10.1111 4.00005 9.81476 4.00005 9.5V6.25049L0.465793 2.21134ZM10.5309 1.33333H1.46923L5.00349 5.37248C5.21616 5.61554 5.33338 5.92753 5.33338 6.25049V9.33333L6.66672 10.3333V6.25049C6.66672 5.92753 6.78394 5.61554 6.99661 5.37248L10.5309 1.33333Z" fill="#4A5565" />
        </svg>

    )
}